import React from 'react';

/**
 * Store the license within a context so that it can
 * be accessed anywhere within the application tree.
 */
const LicenseContext = React.createContext();

export default LicenseContext;
